import { gql } from '@apollo/client'

export const GET_BASE_ARTWORK_DATA = gql`
  query GetBaseArtworkData($id: ID!) {
    artwork(id: $id) {
      artworkOrTourOrArtistImage {
        path
        extension
      }
      endDate
      title
      slug
      id
    }
  }
`

export const TEVO_TICKETS = gql`
  query tevoTickets($artworkPk: Int!, $tevoTicketsLimit: Int, $tevoTicketsOffset: Int) {
    findArtwork(pk: $artworkPk) {
      id

      tevoTicketGroups(limit: $tevoTicketsLimit, offset: $tevoTicketsOffset) {
        id
        section
        retailPrice
        type
        quantity
        row
        availableQuantity
        publicNotes
        splits
        format
        tevoSectionName
        publicNotes

        discount {
          discount
          discountedPrice
          type
          expiresOn
        }
      }

      tevoSeatingChartConfiguration {
        id
      }
    }
  }
`
export const GET_TICKETS_LOWEST_PRICE = gql`
  query GetTicketsLowestPrice($pk: Int!) {
    findArtwork(pk: $pk) {
      id
      pk
      lowestTicketsPrice
    }
  }
`

export const GET_EVENT_AUCTION_BY_ID = gql`
  query GetEventAuctionById($pk: Int!) {
    findArtwork(pk: $pk) {
      # auction and experiences
      id
      pk
      slug
      title
      status
      origin
      salesAs
      description
      eventStartDate
      eventStartDateLocal
      # experiences only
      tevoId
      artistFullName
      salesOnDateLocal
      eventExtendedStatus
      venue {
        # auction and experiences
        id
        zip
        name
        city
        state
        tevoId
        timeZone
        streetAddress
      }
      images {
        # auction and experiences
        edges {
          node {
            id
            path
            extension
          }
        }
      }
      mainArtist {
        # auction and experiences
        fullName
        meta
        slug
      }
      tour {
        id
        title
      }
      artworkOrTourOrArtistImage {
        # auction and experiences
        path
        extension
      }
      packageInfo(status: "public") {
        # experiences only
        id
        pk
        isTicket
      }
    }
  }
`
export const GET_EVENT_TYPE = gql`
  query GetEventType($pk: Int!) {
    findArtwork(pk: $pk) {
      salesAs
      venue {
        timeZone
      }
      auctions {
        edges {
          node {
            end
          }
        }
      }
    }
  }
`
export const GET_AUCTION_BY_ARTWORK = gql`
  query AuctionByArtwork($pk: Int!) {
    auction: findArtwork(pk: $pk) {
      id
      pk
      meta
      nextBid
      subTitle
      currentBid
      startingBid
      deliveryNotes
      purchaseStatus
      startDate
      endDate
    }
  }
`

export const GET_EVENTS_BY_TOUR_SLUG_FOR_SCHEMA = gql`
  query GetEventsByTourSlugForSchema(
    $first: Int
    $tourSlug: String
    $eventStartDate_Gte: DateTime
  ) {
    allArtworks(
      first: $first
      tour_Slug: $tourSlug
      eventStartDate_Gte: $eventStartDate_Gte

      orderBy: "event_start_date"
      salesAs: "buy_it_now_option"
      status: "public"
    ) {
      edges {
        node {
          id
          slug
          title
          eventStartDateLocal
          artworkOrTourOrArtistImage {
            id
            path
            extension
          }
          venue {
            id
            timeZone
            city
            state
            name
          }
          packageInfo {
            id
          }
          tevoId
        }
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
    }
  }
`

export const GET_EVENTS = gql`
  query GetEvents(
    $featuredDateIsNull: Boolean
    $announceDateGte: DateTime
    $eventStartDateGte: DateTime
    $eventStartDateLte: DateTime
    $eventStartDateLocalGte: DateTime
    $eventStartDateLocalLte: DateTime
    $venueCoordinates: String
    $tourSlug: String
    $starSlug: String
    $orderBy: String
    $salesAs: String
    $statusIn: String
    $originIn: String
    $status: String
    $after: String
    $first: Int
  ) {
    allArtworks(
      featuredDate_Isnull: $featuredDateIsNull
      announceDate_Gte: $announceDateGte
      eventStartDate_Gte: $eventStartDateGte
      eventStartDate_Lte: $eventStartDateLte
      eventStartDateLocal_Gte: $eventStartDateLocalGte
      eventStartDateLocal_Lte: $eventStartDateLocalLte
      venueCoordinates: $venueCoordinates
      artists_Slug: $starSlug
      tour_Slug: $tourSlug
      orderBy: $orderBy
      salesAs: $salesAs
      status_In: $statusIn
      origin_In: $originIn
      status: $status
      first: $first
      after: $after
    ) {
      edges {
        node {
          id
          title
          slug
          eventStartDateLocal
          eventStartDate
          artworkOrTourOrArtistImage {
            id
            path
            extension
          }
          venue {
            id
            city
            state
            name
            timeZone
            venuePhoto {
              id
              path
              extension
            }
          }
          tevoId
          hasPackages
          externalLink
          externalVipLink
        }
      }

      pageInfo {
        hasNextPage
        endCursor
      }
    }
  }
`

export const GET_EVENTS_BY_TOUR_SLUG = gql`
  query GetEventsByTourSlug(
    $first: Int
    $last: Int
    $after: String
    $tourSlug: String
    $eventStartDate_Gte: DateTime
  ) {
    allArtworks(
      first: $first
      last: $last
      after: $after
      tour_Slug: $tourSlug

      eventStartDate_Gte: $eventStartDate_Gte
      orderBy: "event_start_date"
      salesAs: "buy_it_now_option"
      status: "public"
    ) {
      edges {
        node {
          id
          slug
          eventStartDateLocal
          venue {
            id
            timeZone
            city
            state
            name
          }
          tevoId
          externalLink
          externalVipLink
          hasPackages
          mainArtist {
            lastParentCategories
          }
          title
        }
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
    }
  }
`

export const STAR_AUCTIONS = gql`
  query StarAuctions(
    $artistsSlug: String
    $after: String
    $first: Int
    $salesAs: String
    $status: String
    $isActive: Boolean
    $partnerSlug: String
  ) {
    allArtworks(
      artists_Slug: $artistsSlug
      salesAs: $salesAs
      status: $status
      isActive: $isActive
      after: $after
      first: $first
      partnerSlug: $partnerSlug
    ) {
      edges {
        node {
          title
          startingBid
          description
          currentBid
          endDate
          venue {
            timeZone
          }
          artworkOrTourOrArtistImage {
            id
            path
            extension
          }
          slug
        }
      }
    }
  }
`
export const GET_AUCTIONS = gql`
  query GetAuctions(
    $first: Int
    $last: Int
    $after: String
    $orderBy: String
    $title_Icontains: String
    $featuredDate_Isnull: Boolean
    $isActive: Boolean
    $ids: String
    $isEnded: Boolean
    $partnerSlug: String
  ) {
    allArtworks(
      first: $first
      last: $last
      after: $after
      orderBy: $orderBy
      title_Icontains: $title_Icontains
      featuredDate_Isnull: $featuredDate_Isnull
      salesAs: "auction"
      status: "public"
      isActive: $isActive
      ids: $ids
      isEnded: $isEnded
      partnerSlug: $partnerSlug
    ) {
      edges {
        node {
          id
          pk
          title
          currentBid
          startingBid
          slug
          artworkOrTourOrArtistImage {
            id
            path
            extension
          }
          endDate
          artistFullName
          venue {
            id
            timeZone
          }
        }
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
    }
  }
`

export const GET_VENUE_AUCTIONS = gql`
  query GetVenueAuctions(
    $featuredDateIsNull: Boolean
    $venueSlug: String
    $orderBy: String
    $after: String
    $first: Int
  ) {
    allArtworks(
      featuredDate_Isnull: $featuredDateIsNull
      venue_Slug: $venueSlug
      salesAs: "auction"
      status: "public"
      isActive: true
      after: $after
      first: $first
      orderBy: $orderBy
    ) {
      edges {
        node {
          id
          slug
          title
          description
          currentBid
          startingBid
          endDate
          artworkOrTourOrArtistImage {
            path
            extension
          }
          venue {
            timeZone
          }
        }
      }

      pageInfo {
        hasNextPage
        endCursor
      }
    }
  }
`
export const GET_VENUE_EVENTS = gql`
  query GetVenueEvents(
    $announceDate_Lt: DateTime
    $featuredDateIsNull: Boolean
    $eventStartDate_Gte: DateTime
    $venueSlug: String
    $salesAs: String
    $orderBy: String
    $status: String
    $after: String
    $first: Int
  ) {
    allArtworks(
      featuredDate_Isnull: $featuredDateIsNull
      venue_Slug: $venueSlug
      salesAs: $salesAs
      after: $after
      first: $first
      status: $status
      eventStartDate_Gte: $eventStartDate_Gte
      announceDate_Lt: $announceDate_Lt
      orderBy: $orderBy
    ) {
      edges {
        node {
          id
          slug
          title
          eventStartDateLocal
          artistFullName
          externalLink
          externalVipLink
          artworkOrTourOrArtistImage {
            path
            extension
          }
          tevoId
          hasPackages
        }
      }
      pageInfo {
        hasNextPage
        endCursor
      }
    }
  }
`

export const GET_MARKETING_EVENT_RELATED_AUCTIONS = gql`
  query GetMarketingEventRelatedAuctions($ids: String!, $announceDate_Lt: DateTime) {
    allArtworks(
      status: "public"
      announceDate_Lt: $announceDate_Lt
      orderBy: "auctions__end"
      ids: $ids
    ) {
      edges {
        node {
          id
          title
          currentBid
          endDate
          startDate
          slug
          salesAs
          venue {
            id
            timeZone
          }
          artworkOrTourOrArtistImage {
            id
            path
            extension
          }
        }
      }
    }
  }
`
